import { createReducer, on } from "@ngrx/store";
import { ICondicionalRelease } from "src/app/shared/interfaces/condicional/icondicional.release";
import { ICondicionalTrigger } from "src/app/shared/interfaces/condicional/icondicional.trigger";
import { ConditionalActions } from "./condicional.actions";


export interface ICondicionalState {
    release: ICondicionalRelease;
    trigger: ICondicionalTrigger
}

const initialState: ICondicionalState = {

    release: {
        clientId: 1,
        serviceReleaseSettingCollection: []
    },

    trigger: {
        clientId: 1,
        enableReviews: {
            trigger: "auto",
            channel: "whatsapp",
            units: [
                1,
                2,
                3
            ]
        },
        enable24hConfirmation: {
            channel: "whatsapp",
            units: [
                1,
                2,
                3
            ]
        },
        enable48hConfirmation: {
            channel: "whatsapp",
            units: [
                1,
                2,
                3
            ]
        },
        enable72hConfirmation: {
            channel: "whatsapp",
            units: [
                1,
                2,
                3
            ]
        },
        enableManualConfirmation: {
            channel: "whatsapp",
            units: [
                1,
                2,
                3
            ]
        },
        sendDataAfterBooking: {
            channel: "whatsapp",
            units: [
                1,
                2,
                3
            ]
        },
        sendScheduleReminders: {
            channel: "whatsapp",
            units: [
                1,
                2,
                3
            ]
        },
        sendDayBeforeReminder: {
            channel: "whatsapp",
            units: [
                1,
                2,
                3
            ]
        },
        nextAppointmentReminder: {
            channel: "whatsapp",
            units: [
                1,
                2,
                3
            ]
        },
        waitingListNotification: {
            channel: "whatsapp",
            units: [
                1,
                2,
                3
            ]
        },
        appointmentCancellationNotification: {
            channel: "whatsapp",
            units: [
                1,
                2,
                3
            ]
        },
        appointmentPreconfirmation: {
            channel: "whatsapp",
            units: [
                1,
                2,
                3
            ]
        }


    }

}

export const condicionalReducer = createReducer(
    initialState,
    on(
        ConditionalActions.loadReleaseSuccess,
        (state, { release }) => ({
            ...state,
            release: release
        })

    ),

    on(
        ConditionalActions.loadTriggerSuccess,
        (state, { trigger }) => ({
            ...state,
            trigger: trigger,
        }))
)